import { create } from 'zustand'

type SidebarWidgetsState = {
  fullViewWidgetId: string | null
  placement: 'left' | 'right'
}

type SidebarWidgetsActions = {
  setFullViewWidgetId: (id: string | null) => void
  toggleFullView: (id: string) => void
  setPlacement: (placement: SidebarWidgetsState['placement']) => void
}

export type SidebarWidgetsStore = SidebarWidgetsState & SidebarWidgetsActions

export const useSidebarWidgetsStore = create<SidebarWidgetsStore>(set => {
  return {
    fullViewWidgetId: null,
    placement: 'left',
    setPlacement: placement => {
      set({ placement })
    },
    setFullViewWidgetId: (id: string | null) => set({ fullViewWidgetId: id }),
    toggleFullView: (id: string) =>
      set(state => ({
        fullViewWidgetId: state.fullViewWidgetId === id ? null : id
      }))
  }
})
